var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmaticSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C5.935 8 1 12.935 1 19L1 41C1 41.552 1.448 42 2 42L38 42C44.065 42 49 37.065 49 31L49 9C49 8.448 48.552 8 48 8L12 8 z M 16.042969 18L17.994141 18L23.154297 32L20.955078 32L19.550781 28L14.484375 28L13.080078 32L10.882812 32L16.042969 18 z M 25 18L27.337891 18L32.027344 29.224609L36.703125 18L39 18L39 32L37 32L37 22.171875L32.875 32L31.181641 32L27 22.076172L27 32L25 32L25 18 z M 17.017578 20.765625L15.181641 26L18.855469 26L17.115234 21.039062L17.017578 20.765625 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmaticSvg);
export default __webpack_public_path__ + "static/media/amatic-svg.9c894d0d27e283debf6c0973d42ef003.svg";
export { ForwardRef as ReactComponent };